import './modules/vue.js';
import { tooltip } from './modules/tippy.js';


const bredi = {
  init: () => {
    tooltip.init();
  },
};

document.addEventListener('DOMContentLoaded', bredi.init);
